module.exports = __webpack_public_path__ + "static/searchFormVerticalFront-5b2441be5bce91395c0f5dd3eb1af075.png";